
import React from 'react'
import Typography from '@mui/material/Typography'
import { grey, shade } from '../../../../colors'
import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'

// interface NoResultsFoundProps {
// /** * TODO. I had to add any here because on some apis response is error:string or sometimes its error.error string. its a hot fix fpr release for now. Neeeds to discsuess
//  * with backend team, Issue occurs when we pass invalid dist series
// {
//   "error": {
//       "error": "The report for the 'Hamza test demo 123' series is not available for the 'Alvernia F2024 Mod 1' term."
//   }
// }
// ***/

//   // message?: any
// }

const NoResultsFound: React.FC = (): JSX.Element => {
  const theme = useTheme()

  return (
        <Box
            padding={theme.spacing(14)}
            border={`1px solid ${shade[650]}`}
            borderRadius={theme.spacing(3)}
            width={'832px'}
            margin={'auto'}
            mt={25}
            justifyContent={'center'}
            display={'flex'}
        >
            <Typography variant="h1" fontSize={'36px'}>No results found</Typography>
            <Typography variant='h4' mt={6} color={grey[850]} fontSize={'20px'}>
                {/* {message?.error ?? message ?? ''} */}
            </Typography>
        </Box>
  )
}

export default NoResultsFound
